import React, { useState } from "react";
import { useNavigate } from "react-router";
import { Container, Button } from "react-bootstrap";

import { useUserData } from "hooks/UserContext";
import ErrorBoundary from "components/ErrorBoundary";
import { LoaderSmall } from "components/Loader";
import notify from "components/UI/toast";

import useMediaQuery from "@mui/material/useMediaQuery";

import { useOrderSummary } from "./hooks/useOrderSummary";
import { PageTitle, Divider, EmptyWrap, SummaryLayout, PageWrap, FixedFooter } from "./styles";
import PersonalDataAccordion from "./_components/PersonalDataAccordion";
import DeliveryAddressAccordion from "./_components/DeliveryAddressAccordion";
import SellerProductGroup from "./_components/SellerProductGroup";
import CartFinancialSummary from "../OrderResume/_components/CartFinancialSummary";
import AddressUpdateModal from "./_components/AddressUpdateModal";

export default function OrderSummary() {
  const navigate = useNavigate();
  const { user, addressShipping } = useUserData();
  const {
    loading,
    itemsBySeller,
    shippingByBrand,
    displayMode,
    cartForSummary,
    hasItems,
    trackCheckoutShippingInfo,
  } = useOrderSummary();

  const isDesktop = useMediaQuery("(min-width:1024px)");

  const [showAddressModal, setShowAddressModal] = useState(false);

  const sellers = Object.keys(itemsBySeller || {});

  function handleGoToPayment() {
    if (!addressShipping || !Object.keys(addressShipping).length) {
      notify("Selecione o endereço de entrega!", "error");
      return;
    }
    // Endereço sem número: abre o popup com "Número" em destaque e bloqueia o avanço.
    if (!addressShipping?.number) {
      setShowAddressModal(true);
      return;
    }
    trackCheckoutShippingInfo();
    navigate("/loja/orderresumepag/");
  }

  if (loading) return <LoaderSmall />;

  const goToPaymentButton = (
    <Button
      type="button"
      className="btn-default-wl text-xs w-100"
      disabled={!hasItems}
      onClick={handleGoToPayment}
    >
      IR PARA PAGAMENTO
    </Button>
  );

  return (
    <ErrorBoundary>
      <div className="wl-page mt-4">
        <PageWrap>
        <Container>
          <PageTitle>Resumo da compra</PageTitle>

          {hasItems ? (
            <SummaryLayout>
              <div className="os-content">
                <PersonalDataAccordion user={user} />
                <Divider />

                <DeliveryAddressAccordion
                  address={addressShipping}
                  onAlterar={() => navigate("/loja/list-addresses/")}
                />
                <Divider />

                {sellers.map((sellerName) => (
                  <React.Fragment key={sellerName}>
                    <SellerProductGroup
                      sellerName={sellerName}
                      products={itemsBySeller[sellerName]}
                      shippingByBrand={shippingByBrand}
                      displayMode={displayMode}
                    />
                    <Divider />
                  </React.Fragment>
                ))}
              </div>

              <div className="os-summary">
                <CartFinancialSummary
                  cart={cartForSummary}
                  displayMode={displayMode}
                />
                {isDesktop && (
                  <div className="os-actions">
                    {goToPaymentButton}
                  </div>
                )}
              </div>
            </SummaryLayout>
          ) : (
            <EmptyWrap>
              <p>Você ainda não adicionou produtos à sua sacola.</p>
              <Button
                type="button"
                className="btn-default-wl text-xs"
                style={{ width: 180 }}
                onClick={() => navigate("/loja")}
              >
                IR PARA HOME
              </Button>
            </EmptyWrap>
          )}
        </Container>
        </PageWrap>
      </div>

      {!isDesktop && (
        <FixedFooter>
          {goToPaymentButton}
        </FixedFooter>
      )}

      <AddressUpdateModal
        show={showAddressModal}
        onClose={() => setShowAddressModal(false)}
        address={addressShipping}
        onSaved={() => {
          setShowAddressModal(false);
          trackCheckoutShippingInfo();
          navigate("/loja/orderresumepag/");
        }}
      />
    </ErrorBoundary>
  );
}
